import React, { useContext } from 'react';
import { FaSearch, FaUser, FaShoppingCart } from 'react-icons/fa';
import { getSystemSettings } from '../../../../functions/Functions';
import { SettingsContext } from '../../../../contexts/Settings';

const DigitalMenuHeader = ({
  isOrderPunchingEnabled,
  searchQuery,
  setSearchQuery,
  orderDetail,
  setIsCustomerModalOpen,
  cartItems,
  setIsCartOpen
}) => {
  const { generalSettings } = useContext(SettingsContext);
  const cartItemsCount = Object.values(cartItems)?.length ?? 0;

  return (
    <div className="d-flex box-shadow-light justify-content-between align-items-center px-md-3 pb-1">
      <div className="brand-logo">
        <img
          src={generalSettings && `${getSystemSettings(generalSettings, "type_logo")}`}
          alt="logo"
          className="menu-logo"
        />
      </div>
      
      {/* Modern Search Bar & Icons */}
      <div className="modern-search-wrapper">
        <div className="d-flex align-items-center gap-2">
          <div className="position-relative search-input-container flex-grow-1">
            <FaSearch className="menu-search-icon text-muted position-absolute" />
            <input
              type="text"
              className="form-control form-control-sm search-input"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          
          {/* Cart Icon in Header */}
          {
            isOrderPunchingEnabled && (
              <>
                <button 
                  className="btn btn-light rounded-circle shadow-sm d-flex align-items-center justify-content-center p-0 flex-shrink-0 header-action-btn"
                  onClick={() => setIsCustomerModalOpen(true)}
                  aria-label="Customer Info"
                >
                  <FaUser className="header-action-icon" />
                </button>
                <button 
                  className="btn btn-light rounded-circle shadow-sm d-flex align-items-center justify-content-center p-0 flex-shrink-0 header-action-btn position-relative"
                  onClick={() => setIsCartOpen(true)}
                  aria-label="View Cart"
                >
                  <FaShoppingCart className="header-action-icon" />
                  {cartItemsCount > 0 && (
                    <span className="position-absolute top-0 right-0 badge rounded-pill text-white header-cart-badge">
                      {cartItemsCount}
                    </span>
                  )}
                </button>
              </>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default React.memo(DigitalMenuHeader);
